import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetRecoverPasswordInput } from '../domain/dtos/get-recover-password-input'
import { GetRecoverPasswordOutput } from '../domain/dtos/get-recover-password-output'
import { ErrorCode } from '../domain/enums/error-code'
import { GeneralError } from '../domain/errors/general'
import { InvalidCaptchaError } from '../domain/errors/invalid-captcha-error'
import { Envs } from '../envs'

export class GetRecoverPassword {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetRecoverPasswordInput): Promise<GetRecoverPasswordOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/auth/recover-password/${input.token}`,
      body: input,
    })

    if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    switch (response.data.code) {
      case ErrorCode.INVALID_CAPTCHA:
        throw new InvalidCaptchaError()
      default:
        throw new GeneralError('recoverPassword')
    }
  }
}
